import { gql } from '@apollo/client';

export const GET_WORKSPACE_FORM = gql`
  query GetWorkspaceForm($id: ID!) {
    workspaceForm: getWorkspaceForm(id: $id) {
      id
      name
      description
      template {
        id
      }
      dataset {
        id
      }
    }
  }
`;
